import * as XLSX from 'xlsx';

/** Users must never see "null"/"undefined" in exports or prints. */
const cleanValue = (value: any) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') {
    const s = value.trim();
    if (s === 'null' || s === 'undefined') return '';
  }
  return value;
};

const cleanRows = (data: any[]) =>
  data.map((row) =>
    Object.fromEntries(Object.entries(row).map(([k, v]) => [k, cleanValue(v)]))
  );

/**
 * Utility function to export data to Excel (.xlsx format)
 * @param data - Array of objects to export
 * @param filename - Name of the file (without extension)
 */
export const exportToExcel = (data: any[], filename: string) => {
  if (data.length === 0) {
    alert('No data to export');
    return;
  }

  // Create worksheet from data
  const worksheet = XLSX.utils.json_to_sheet(cleanRows(data));
  
  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  
  // Generate Excel file and trigger download
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

/**
 * Print table data as Excel
 * Opens a new window with formatted table for printing
 */
export const printAsExcel = (data: any[], title: string) => {
  if (data.length === 0) {
    alert('No data to print');
    return;
  }

  const headers = Object.keys(data[0]);
  const rows = cleanRows(data);

  const htmlContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
          }
          h1 {
            text-align: center;
            color: #1f2937;
            margin-bottom: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          th {
            background-color: #2563eb;
            color: white;
            padding: 12px;
            text-align: left;
            font-weight: 600;
            border: 1px solid #ddd;
          }
          td {
            padding: 10px;
            border: 1px solid #ddd;
          }
          tr:nth-child(even) {
            background-color: #f9fafb;
          }
          tr:hover {
            background-color: #f3f4f6;
          }
          @media print {
            body {
              margin: 0;
            }
            @page {
              margin: 1cm;
            }
          }
        </style>
      </head>
      <body>
        <h1>${title}</h1>
        <table>
          <thead>
            <tr>
              ${headers.map(header => `<th>${header}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${rows.map(row => `
              <tr>
                ${headers.map(header => `<td>${row[header] ?? ''}</td>`).join('')}
              </tr>
            `).join('')}
          </tbody>
        </table>
        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  }
};

